import { PDFDownloadLink } from "@react-pdf/renderer";
import styled from "styled-components";

import { StyledButton } from "../OrderHeader";
import { ClearOrderDocument, Props } from "./ClearOrderDocument";

const StyledPDFDownloadLink = styled(PDFDownloadLink)`
  text-decoration: none;
  color: var(--primary-color);
`;

type DownloadButtonProps = {
  data: Props;
  isLogoLoading?: boolean;
};

export function ClearOrderProDownloadButton({
  data,
  isLogoLoading = false,
}: DownloadButtonProps) {
  // Show loading state while logo is being fetched
  if (isLogoLoading) {
    return (
      <StyledButton
        className="p-button-text p-button-primary p-0 mb-0"
        icon="pi pi-spin pi-spinner"
        disabled
      >
        <span style={{ textDecoration: "none", color: "var(--primary-color)" }}>
          Loading...
        </span>
      </StyledButton>
    );
  }

  return (
    <StyledButton
      className="p-button-text p-button-primary p-0 mb-0"
      icon="pi pi-file"
    >
      <StyledPDFDownloadLink
        data-testid="download-pdf_OrderHeader_DownloadLink"
        document={<ClearOrderDocument {...data} />}
        fileName={`clear_order__${new Date().getTime()}.pdf`}
      >
        {({ loading }) => (loading ? "Loading..." : "Download PDF")}
      </StyledPDFDownloadLink>
    </StyledButton>
  );
}
